
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');

 
const KpiNightDriveActions = (props) => {
    const handleOverspeedClick = (e) => {
        e.stopPropagation();
        //console.log("Overspeed ",props);
        props.context.componentParent.onShowNightDriveKpi(props);
    };
    

    return (
        <div>
			<button onClick={handleOverspeedClick} className="custom-btn f22 label label-success" title="Night Drive" ><i className="icofont icofont-full-night txt-primary"></i> &nbsp;</button>
            
        </div>
    );
};

export default KpiNightDriveActions;
